jQuery(document).ready(function ($) {
    const teaser_galleries = $('.teaser').each(function () {
        if ($(this).find('.teaser__gallery').length > 0) {
            const gallery_class = `#${$(this).attr('id')} .teaser__gallery`;

            const teaser_gallery = new Swiper(gallery_class, {
                loop: true,

                slidesPerView: 1,

                spaceBetween: 0,

                slideClass: 'teaser__image',

                navigation: {
                    prevEl: '.teaser__arrow-left',
                    nextEl: '.teaser__arrow-right'
                },

                pagination: {
                    el: '.teaser__pagination',
                    type: 'bullets',
                    bulletClass: 'pagination__bullet',
                    bulletActiveClass: 'active',
                    clickable: true
                },

                autoplay: {
                    delay: 5000,
                },
                speed: 500,

                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                }
            });
        }
    });
});